export default __webpack_public_path__ + "static/media/light-theme-hero_converted.706fd508.jpg";